import PropTypes from 'prop-types';

import Forms from '@components/forms/component';

import { form_container, no_wrap } from '../styles.module.scss';

const StepOne = ({
  agent,
  userInfo,
  listingId,
  nextStepCallback,
  loggedInUserId,
  associatedAgentId,
  agentCallback,
  agentId,
  openHouse
}) => {
  return (
    <div>
      <h2>Welcome! Please Sign In.</h2>
      <p>
        {openHouse && (
          <>
            Hosted by {agent?.displayPrimary} on <span className={no_wrap}>{openHouse}</span>
          </>
        )}
      </p>
      <div className={form_container}>
        <Forms
          theme="no-background"
          userInfo={userInfo}
          workingWithAgentField={true}
          linkLabel="Submit"
          endpointId={listingId}
          nextStepCallback={nextStepCallback}
          agent={agent}
          loggedInUserId={loggedInUserId}
          associatedAgentId={associatedAgentId}
          agentCallback={agentCallback}
          agentId={agentId}
          consentToBeContactedByAgent={true}
          endpoint="open house"
          details=""
        />
      </div>
    </div>
  );
};

StepOne.propTypes = {
  agent: PropTypes.object,
  userInfo: PropTypes.object,
  listingId: PropTypes.string,
  nextStepCallback: PropTypes.func,
  loggedInUserId: PropTypes.string,
  associatedAgentId: PropTypes.string,
  agentCallback: PropTypes.func,
  agentId: PropTypes.string,
  openHouse: PropTypes.string
};

export default StepOne;
